module.exports = __webpack_public_path__ + "img/landliebe-6374.f021f8d9.jpeg";